import { Trascodifica } from ".";

export class DocumentoImmobile {

    id: number;
    nomeFile: string;
    idImmobile: number;
    idTipologiaDocumento: number;
    tipologiaDocumento: Trascodifica;

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/documento-immobile.ts